export default class subscriberCustomData {
    constructor() {
        return {
            scope: {
                subscriber: "="
            },
            template: require('../../../../views/subscriber/show/subscriber-custom-data.html'),
            controller: [
                '$scope', '$element', '$attrs', '$stateParams', '$filter', 'Customization', 'Subscriber', 'Events',
                (scope, element, attr, $stateParams, $filter, Customization, Subscriber, Events) => {

                scope.isArray = angular.isArray;

                Subscriber.customFields($stateParams.id).then((response) => {
                    scope.customGroups = response.data;
                });

                scope.toggleSize = (group) => {
                    group.maximized = ! group.maximized;
                };

                var getIndex = (groupId) => {
                    for (var i = 0; i < scope.customGroups.length; i++) {
                        if (scope.customGroups[i].id === groupId) {
                            return i;
                        }
                    }
                };

                scope.hasNext = (group) => {
                    var groupIndex = getIndex(group.id);
                    var customGroup = scope.customGroups[groupIndex];

                    if (! group.index) {
                        group.index = 0;
                    }

                    if (group.index === 0 && customGroup.fields.length > 1) {
                        return true;
                    }

                    return !angular.isUndefined(customGroup.fields[group.index + 1]);
                };

                scope.hasPrev = (group) => {
                    var groupIndex = getIndex(group.id);
                    var customGroup = scope.customGroups[groupIndex];

                    if (! group.index) {
                        group.index = 0;
                    }

                    if (group.index === 0) {
                        return false;
                    }

                    return !angular.isUndefined(customGroup.fields[group.index - 1]);
                };

                scope.showNext = (group, event) => {
                    event.stopPropagation();

                    if (! group.index) {
                        group.index = 0;
                    }

                    group.index++;
                };

                scope.showPrev = (group, event) => {
                    event.stopPropagation();
                    if (! group.index) {
                        group.index = 0;
                    }

                    group.index--;
                };

                scope.getField = (fieldName) => {
                    return scope.fieldData[fieldName];
                };

                scope.updateCustomFieldData = (group, field) => {
                    var attributes = {
                        subscriber_id: $stateParams.id,
                        field: {
                            key: group.name + '.' + field.name,
                            value: field.value,
                            type: field.type
                        }
                    };

                    Customization.updateFieldData(attributes).then(() => {
                        Events.flashEvent('notification', $filter('translate')('GLOBAL:UPDATED'))
                    });
                };
            }]
        };
    }
}